export default __webpack_public_path__ + "static/es-9138c3c0a599c3036a65e9bcc4772c83.svg";